import { render, staticRenderFns } from "./widget-ASIN.vue?vue&type=template&id=9840f19a&scoped=true&"
import script from "./widget-ASIN.vue?vue&type=script&lang=js&"
export * from "./widget-ASIN.vue?vue&type=script&lang=js&"
import style0 from "./widget-ASIN.vue?vue&type=style&index=0&id=9840f19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9840f19a",
  null
  
)

export default component.exports